module.exports = __webpack_public_path__ + "img/pic_location_MiaoliCounty.388272ef.png";